import { Link } from "react-router-dom";
import { PublicNav, PublicFooter } from "@/components/PublicChrome";

export const LegalLayout = ({ title, effective, children }) => (
  <div className="min-h-screen bg-background flex flex-col">
    <PublicNav />
    <main className="flex-1">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-14">
        <Link to="/" className="text-sm text-muted-foreground hover:text-foreground transition-colors">← Back to home</Link>
        <h1 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">Effective date: {effective}</p>
        <div className="legal-body mt-10">{children}</div>
      </div>
    </main>
    <PublicFooter />
  </div>
);

export const Section = ({ heading, children }) => (
  <section className="mb-9">
    <h2 className="font-heading text-xl font-semibold tracking-tight mb-3">{heading}</h2>
    <div className="space-y-3 text-[15px] leading-relaxed text-foreground/80">{children}</div>
  </section>
);
